module.exports = __webpack_public_path__ + "img/pantalla-7-2.9af6f397.png";